// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { GetSingleUser, loginUser } from './authServiceSync';

const initialState = {
  loading: false,
  user: null,
  token: localStorage.getItem('admin_token')
    ? localStorage.getItem('admin_token')
    : null,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('admin_token');
      toast.info('Logged out successfully');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload?.data?.admin;
        state.token = payload?.data.token;
      })
      .addCase(loginUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(GetSingleUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload.data;
      })
      .addCase(GetSingleUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
